// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import { Component } from 'react';
import styled from 'styled-components';
import { GYPSUM } from 'HubStyleTokens/colors';
import SkeletonBase from 'conversations-skeleton-state/components/SkeletonBase';
import SkeletonContainer from 'conversations-skeleton-state/components/SkeletonContainer';
import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MessageBubble = styled(SkeletonBase).withConfig({
  displayName: "ThreadViewMessagePlaceholder__MessageBubble",
  componentId: "jfy1gq-0"
})(["display:flex;flex-direction:column;width:100%;padding:16px;border-radius:5px;"]);
export default class ThreadViewMessagePlaceholder extends Component {
  render() {
    return /*#__PURE__*/_jsx(SkeletonContainer, {
      background: GYPSUM,
      padding: 20,
      children: /*#__PURE__*/_jsxs("div", {
        className: "align-end",
        children: [/*#__PURE__*/_jsx(SkeletonCircle, {
          className: "m-right-2",
          use: "on-shade"
        }), /*#__PURE__*/_jsxs(MessageBubble, {
          use: "on-shade",
          children: [/*#__PURE__*/_jsx(SkeletonBox, {
            use: "blank",
            height: "0.75em",
            width: "60%"
          }), /*#__PURE__*/_jsx(SkeletonBox, {
            className: "m-top-3",
            use: "blank",
            height: "0.75em",
            width: "80%"
          }), /*#__PURE__*/_jsx(SkeletonBox, {
            className: "m-top-3",
            use: "blank",
            height: "0.75em",
            width: "100%"
          })]
        })]
      })
    });
  }
}
ThreadViewMessagePlaceholder.displayName = 'ThreadViewMessagePlaceholder';